
import { RichText, useBlockProps } from '@wordpress/block-editor';
import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import produce from 'immer';
import './editor.scss';

import Settings from './Settings';
import Sliders from './Sliders';
import Style from './Style';

import BPLSDK from '../bplugins_sdk/src/components/v1/BPLSDK';

const Edit = (props) => {

	const { attributes, setAttributes, clientId } = props;
	const { sliders, position, titleAnimation, descAnimation, btnAnimation } = attributes;

	useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]);

	const [activeIndex, setActiveIndex] = useState(0);
	const [carousel, setCarousel] = useState(null);

	const updateSlider = (type, index, val, childType = false) => {
		const newSlider = produce(sliders, draft => {
			if (childType) {
				draft[index][type][childType] = val;
			} else {
				draft[index][type] = val;
			}
		});
		setAttributes({ sliders: newSlider });
	}

	//  Add Slider
	const addSlider = () => {
		setAttributes({
			sliders: [
				...sliders,
				{
					img: { url: 'https://bblockswp.com/wp-content/demo/img/white-blooming-flower-under-the-tree.jpg' },
					title: `Card Title-${sliders.length + 1}`,
					desc: `This is description here-${sliders.length + 1}`,
					btnLabel: "",
					btnUrl: "https://wordpress.org/plugins/b-slider/",
					target: false
				}
			]
		})
	}

	//   Remove Slider
	const removeSlider = (index) => {
		const removeSlider = [...sliders];
		removeSlider.splice(index, 1);
		setAttributes({ sliders: removeSlider });

		carousel?.to(index === 0 ? index : index - 1);
		setActiveIndex(index === 0 ? index : index - 1);
	}

	//  Card Duplicate 
	const duplicateSlider = (index) => {
		const newSliders = [...sliders.slice(0, index), { ...sliders[index] }, ...sliders.slice(index)];
		setAttributes({ sliders: newSliders });

		carousel?.to(index + 1);
		setActiveIndex(index + 1);
	}

	// Slide To ActiveIndex 
	useEffect(() => {
		carousel?.to(activeIndex || 0);
	}, [activeIndex]);

	return (
		<div {...useBlockProps()} id={`bsbCarousel-${clientId}`}>

			<BPLSDK setAttributes={setAttributes} />

			<Settings clientId={clientId} attributes={attributes} setAttributes={setAttributes} updateSlider={updateSlider} addSlider={addSlider} removeSlider={removeSlider} duplicateSlider={duplicateSlider} isBackend={true} custom={{ activeIndex, setActiveIndex }} />

			<Style attributes={attributes} clientId={clientId} />

			<Sliders attributes={attributes} clientId={clientId} isBackend={true} custom={{ activeIndex, carousel, setCarousel }}>
				<div className="carousel-inner">
					{sliders.map((slider, index) => {
						const { img, title, desc, btnLabel } = slider || {};

						const captionClass = position?.top ? ('0' === position.top ? `center-center` : 'bottom-center') : position?.split(' ')?.join('-');

						return <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
							{img?.url && <img src={img.url} className="d-block w-100" alt={img?.alt || img?.title} />}

							<div className="carousel-caption">
								<div className={`captionContent ${captionClass}`}>

									<RichText tagName="h5" className={`animate__animated animate__${titleAnimation.effect}`} value={title} onChange={(val) => updateSlider('title', index, val)} placeholder={__('Heading...')} inlineToolbar />

									<RichText tagName="p" className={`animate__animated animate__${descAnimation.effect}`} value={desc} onChange={(val) => updateSlider('desc', index, val)} placeholder={__('Description...')} inlineToolbar />

									{btnLabel &&
										<div className={`carousel-button animate__animated animate__${btnAnimation.effect}`}>
											<RichText tagName="a" value={btnLabel} onChange={(val) => updateSlider('btnLabel', index, val)} allowedFormats={['core/bold', 'core/italic']} placeholder={__('Enter Label')} inlineToolbar />
										</div>
									}
								</div>
							</div>
						</div>
					})}
				</div>
			</Sliders>

		</div>
	);
};
export default Edit;